import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
const NAV_LEFT = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Philosophy',
  href: '#philosophy'
}, {
  label: 'Destinations',
  href: '#destinations'
}];
const NAV_RIGHT = [{
  label: 'Beyond',
  href: '#beyond'
}, {
  label: 'How It Works',
  href: '#how-it-works'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const logoSrc = 'https://cdn.magicpatterns.com/uploads/uCxAG9G8XRJkgLABzP5wZi/3dots-logo-white-sanitized.svg';
  const allNavItems = [...NAV_LEFT, ...NAV_RIGHT];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-primary shadow-md' : 'bg-transparent'}`} data-id="element-17">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-18">
        <div className="flex items-center justify-between h-20 lg:h-24" data-id="element-19">
          {/* Desktop: Left Nav */}
          <div className="hidden lg:flex items-center space-x-8 flex-1" data-id="element-20">
            {NAV_LEFT.map(item => <a key={item.href} href={item.href} onClick={e => handleNavClick(e, item.href)} className="text-xs font-medium uppercase tracking-[0.2em] transition-colors text-white hover:text-accent" data-id="element-21">
                {item.label}
              </a>)}
          </div>

          {/* Mobile: Hamburger */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-white transition-colors" aria-label="Toggle menu" data-id="element-22">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-23">
              {isMobileMenuOpen ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" data-id="element-24" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" data-id="element-25" />}
            </svg>
          </button>

          {/* Center: Logo */}
          <div className="flex-shrink-0 flex items-center justify-center" data-id="element-26">
            <a href="#hero" onClick={e => handleNavClick(e, '#hero')} className="flex items-center" data-id="element-27">
              <img src={logoSrc} alt="3 DOTS Travel" className="h-10 lg:h-12 w-auto transition-all duration-500" data-id="element-28" />
            </a>
          </div>

          {/* Desktop: Right Nav */}
          <div className="hidden lg:flex items-center space-x-8 flex-1 justify-end" data-id="element-29">
            {NAV_RIGHT.map(item => <a key={item.href} href={item.href} onClick={e => handleNavClick(e, item.href)} className="text-xs font-medium uppercase tracking-[0.2em] transition-colors text-white hover:text-accent" data-id="element-30">
                {item.label}
              </a>)}
          </div>

          {/* Mobile: CTA placeholder for balance */}
          <div className="lg:hidden w-10" data-id="element-31" />
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="lg:hidden py-8 bg-primary border-t border-white/10" data-id="element-32">
            <div className="flex flex-col items-center space-y-5" data-id="element-33">
              {allNavItems.map(item => <a key={item.href} href={item.href} onClick={e => handleNavClick(e, item.href)} className="text-xs font-medium uppercase tracking-[0.2em] text-white hover:text-accent transition-colors" data-id="element-34">
                  {item.label}
                </a>)}
              <div className="pt-4" data-id="element-35">
                <Button variant="outline" size="sm" onClick={e => {
              e.preventDefault();
              const element = document.querySelector('#contact');
              if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
              setIsMobileMenuOpen(false);
            }} className="uppercase tracking-[0.15em] text-xs border-white text-white hover:bg-white hover:text-primary" data-id="element-36">
                  Plan Your Journey
                </Button>
              </div>
            </div>
          </div>}
      </div>
    </nav>;
}